import {
    SCROLL_VALUE
  } from "./types";
  
  export const scrollChange = (value) => {
    return (dispatch, getState) => {
      dispatch({
        type: SCROLL_VALUE,
        data: value
      });
    };
  };
  


// WEBPACK FOOTER //
// ./src/actions/scroll.js